// extracted by mini-css-extract-plugin
export var currencyInput = "_oe-1";
export var currencySymbol = "_oe-0";